import React, { useState, useEffect } from 'react';
// Smooth scroll function
const smoothScroll = (e, targetId) => {
  e.preventDefault();
  const element = document.getElementById(targetId);
  if (element) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
};

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const navLinks = [
    { name: 'Home', to: 'home' },
    { name: 'Services', to: 'services' },
    { name: 'Coverage', to: 'coverage' },
    { name: 'Packages', to: 'packages' },
    // { name: 'About', to: 'about' },
    // { name: 'Contact', to: 'contact' },
  ];

  const handleNavClick = (e, to) => {
    smoothScroll(e, to);
    closeMenu();
  };

  return (
    <>
      <nav className={`navbar navbar-expand-lg fixed-top ${scrolled ? 'scrolled' : ''}`}>
        <div className="container">
          <a 
            className="navbar-brand" 
            href="#home"
            onClick={(e) => handleNavClick(e, 'home')}
          >
            <i className="fas fa-wifi text-primary"></i> <span>Telvix</span>
          </a>
          
          <button 
            className={`navbar-toggler border-0 shadow-none ${isOpen ? 'open' : ''}`} 
            type="button"
            onClick={toggleMenu}
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon">
              <span className="toggler-line"></span>
              <span className="toggler-line"></span>
              <span className="toggler-line"></span>
            </span>
          </button>
          
          <div className={`collapse navbar-collapse ${isOpen ? 'show' : ''}`} id="navbarNav">
            <ul className="navbar-nav ms-auto align-items-center">
              {navLinks.map((link) => (
                <li className="nav-item" key={link.to}>
                  <a
                    href={`#${link.to}`}
                    className="nav-link"
                    onClick={(e) => handleNavClick(e, link.to)}
                  >
                    {link.name}
                  </a>
                </li>
              ))}
              <li className="nav-item ms-lg-3 mt-3 mt-lg-0">
                <a
                  href="#packages"
                  className="btn btn-primary rounded-pill px-4"
                  onClick={(e) => handleNavClick(e, 'packages')}
                >
                  Get Started <i className="fas fa-arrow-right ms-1"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      
      {/* Mobile Menu Overlay */}
      {isOpen && (
        <div 
          className="mobile-menu-overlay" 
          onClick={closeMenu}
          style={{
            position: 'fixed',
            top: '80px',
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 1040,
            display: 'block'
          }}
        ></div>
      )}
      
      <style jsx>{`
        .navbar {
          transition: all 0.3s ease;
        }
        .navbar.scrolled {
          box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
        }
        .navbar-toggler {
          padding: 0.5rem;
        }
        .navbar-toggler:focus {
          box-shadow: none;
        }
        .toggler-line {
          display: block;
          width: 24px;
          height: 2px;
          background-color: var(--primary-color);
          margin: 5px 0;
          transition: all 0.3s ease;
        }
        .navbar-toggler.open .toggler-line:nth-child(1) {
          transform: rotate(45deg) translate(5px, 5px);
        }
        .navbar-toggler.open .toggler-line:nth-child(2) {
          opacity: 0;
        }
        .navbar-toggler.open .toggler-line:nth-child(3) {
          transform: rotate(-45deg) translate(5px, -5px);
        }
        .nav-link {
          position: relative;
          padding: 0.5rem 1rem;
          font-weight: 500;
          color: var(--text-color) !important;
          transition: all 0.3s ease;
        }
        .nav-link::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 1rem;
          width: 0;
          height: 2px;
          background: linear-gradient(90deg, var(--primary-color), var(--secondary-color));
          transition: width 0.3s ease;
        }
        .nav-link:hover::after,
        .nav-link.active::after {
          width: calc(100% - 2rem);
        }
        @media (max-width: 991.98px) {
          .navbar-collapse {
            padding: 1rem;
            background: white;
            border-radius: 0.5rem;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
            margin-top: 1rem;
          }
          .nav-item {
            margin: 0.5rem 0;
          }
        }
      `}</style>
    </>
  );
};

export default Navbar;
